// extracted by mini-css-extract-plugin
export default {"form_item":"DashboardComponents_form_item__QpT3r","fadeIn":"DashboardComponents_fadeIn__3SD9t"};